import React, { useState, useEffect } from "react";
import { IGlobalOccupancyProps } from "./GlobalOccupancyProps";
import { Container, BookMoreRoomsMessage } from "./GlobalOccupancyHelpers";
import Incrementor from "../../Incrementor/Incrementor";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Room } from "../../../../models/room";

const GlobalOccupancy: React.FC<IGlobalOccupancyProps> = ({
  rooms,
  setOccupancy,
  isSearchModal,
  setOccupancyDropdown,
  isEditReservation = false,
  isOfferModal,
}) => {
  const [showScroller, setShowScroller] = useState<boolean>(false);
  useEffect(() => {
    const isExist = rooms.find((elem) => elem.childrenAges.length > 0);
    setShowScroller(isExist ? true : false);
  }, [rooms]);

  const handleChangeAdultsCount = (index: number, newValue: number) => {
    const currentRooms = [...rooms];
    currentRooms[index] = { ...currentRooms[index], adults: newValue };
    setOccupancy(currentRooms);
  };

  const handleChangeChildrenCount = (index: number, newValue: number) => {
    // const currentRooms = JSON.parse(JSON.stringify(rooms))
    const currentRooms = [...rooms];
    const currentRoomChildrenAges: Array<string | number> = [
      ...currentRooms[index]["childrenAges"],
    ];
    if (
      currentRooms[index]["children"] > newValue &&
      currentRooms[index]["childrenAges"]
    ) {
      currentRoomChildrenAges.pop();
      // delete currentRooms[index].childrenAges[`kid${newValue + 1}`]
      currentRooms[index] = {
        ...currentRooms[index],
        children: newValue,
        childrenAges: currentRoomChildrenAges,
      };
    } else {
      currentRoomChildrenAges.push("");
      currentRooms[index] = {
        ...currentRooms[index],
        children: newValue,
        childrenAges: currentRoomChildrenAges,
      };
    }
    setOccupancy(currentRooms);
  };

  const handleRemoveRoom = (index: number) => {
    const currentRooms = [...rooms];
    currentRooms.splice(index, 1);
    setOccupancy(currentRooms);
  };

  const handleRemoveRoomKeyPress = (index: number, code: string) => {
    if (code === "Enter" || code === " ") {
      const currentRooms = [...rooms];
      currentRooms.splice(index, 1);
      setOccupancy(currentRooms);
    }
  };

  const handleAddRoom = () => {
    const currentRooms = [...rooms];
    const newRoom = new Room();
    currentRooms.push(newRoom);
    setOccupancy(currentRooms);
  };

  const handleChangeChildrenAge = (event: any, index: number) => {
    const currentRooms = [...rooms];
    const childElement = event.target;
    const childIndex = childElement.dataset["childindex"];

    const currentRoomChildAges: Array<string | number> = [
      ...currentRooms[index].childrenAges,
    ];
    currentRoomChildAges[childIndex] = !Number.isNaN(
      parseInt(childElement.value)
    )
      ? parseInt(childElement.value)
      : "";
    currentRooms[index] = {
      ...currentRooms[index],
      childrenAges: currentRoomChildAges,
    };
    setOccupancy(currentRooms);
  };

  const renderChildrenDropdown = (inputField: any, index: number) => {
    const { childrenAges, children } = inputField;
    const dropdown = [];
    const ageOptions = [
      <option value="" key={`age-no`}>
        {" "}
        Age
      </option>,
    ];
    for (let i = 0; i <= 17; i++) {
      ageOptions.push(
        <option value={i} key={`age-${i}`}>
          {i}
        </option>
      );
    }
    for (let i = 0; i < children; i++) {
      dropdown.push(
        <Col
          xs={6}
          key={i}
          className={`${isOfferModal ? "child-dropdown" : ""} ${
            roomCount > 1 ? "multi-room-child" : ""
          }`}
        >
          <div
            className={`childrenContainer ${
              roomCount > 1 ? " multiContainer" : ""
            }`}
          >
            <Form.Label
              className={`child-label labels ${
                roomCount > 1 ? " room-guests" : ""
              }`}
            >
              Child {i + 1}
            </Form.Label>
            <Form.Control
              as="select"
              className={`select-child ${
                roomCount > 1 ? "multi-select-child" : ""
              }`}
              name={`child${i}`}
              data-childindex={i}
              onChange={(e) => handleChangeChildrenAge(e, index)}
              value={childrenAges && childrenAges[i]}
            >
              {ageOptions}
            </Form.Control>
          </div>
        </Col>
      );
    }
    return dropdown;
  };

  const roomCount = rooms.length;
  return (
    <Container className="p-3" showScroll={showScroller}>
      <Row className="labels justify-content-between g-0">
        {isEditReservation ? null : (
          <Col xs={{ span: 3, offset: 0 }} className="rooms-label">
            Rooms
          </Col>
        )}
        <Col xs={3} className="room-increment text-center" id="adults-labels">
          Adults
        </Col>
        <Col xs={3} className="room-increment text-center" id="children-label">
          Children
        </Col>
        {roomCount > 1 && <Col className="remove-room" />}
      </Row>
      <div className="rooms-container">
        {rooms.map(
          (inputField: { adults: number; children: number }, index: number) => (
            <div key={`${inputField}~${index}`} className="room-row">
              <Row
                className={`d-flex justify-content-between g-0${
                  isOfferModal ? " offer-modal-guests" : ""
                } `}
              >
                {!isEditReservation ? (
                  <Col xs={3}>
                    <span className="room-label">Room {index + 1}</span>
                  </Col>
                ) : null}
                <Col xs={3} className="room-increment">
                  <Form.Label srOnly>Adults for Room {index + 1}</Form.Label>
                  <Incrementor
                    name="adults"
                    value={inputField.adults}
                    onChangeCount={handleChangeAdultsCount}
                    min={1}
                    max={8 - inputField.children}
                    index={index}
                  />
                </Col>
                <Col xs={3} className="room-increment">
                  <Form.Label srOnly>Children for Room {index + 1}</Form.Label>
                  <Incrementor
                    name="children"
                    value={inputField.children}
                    onChangeCount={handleChangeChildrenCount}
                    min={0}
                    max={8 - inputField.adults}
                    index={index}
                  />
                </Col>
                {roomCount > 1 && (
                  <Col className="text-center remove-room">
                    <a
                      title="Remove room"
                      className="bg-dark close-icon close-icon-styles"
                      role="button"
                      tabIndex={0}
                      onClick={() => handleRemoveRoom(index)}
                      aria-label={`remove room`}
                      onKeyPress={(event) => {
                        const code = event.key;
                        handleRemoveRoomKeyPress(index, code);
                      }}
                      id={"remove-room"}
                    >
                      &times;
                    </a>
                  </Col>
                )}
              </Row>
              <Row>
                {inputField.children !== 0
                  ? renderChildrenDropdown(inputField, index)
                  : null}
              </Row>
            </div>
          )
        )}
      </div>
      {!isEditReservation && roomCount < 3 ? (
        !isSearchModal ? (
          <div className="actions">
            <Button
              onClick={handleAddRoom}
              variant="primary"
              aria-label={`Add Room`}
              className="w-100 add-room-styles"
              id="add-room-in-global-occupancy"
            >
              Add Room +
            </Button>
          </div>
        ) : (
          <Button
            onClick={handleAddRoom}
            aria-label={`Add Room`}
            variant="secondary"
            className="add-room-styles-mobile"
            id="add-room-in-global-occupancy"
          >
            Add Room +
          </Button>
        )
      ) : !isEditReservation ? (
        <BookMoreRoomsMessage />
      ) : null}
      {isSearchModal ? (
        <Button
          variant="secondary"
          type={`button`}
          onClick={setOccupancyDropdown}
          className="closeButton"
        >
          Close
        </Button>
      ) : null}
    </Container>
  );
};

export default GlobalOccupancy;
